import { hocSinhHoTroReducer } from './hocSinhHoTroReducer';
import { hocSinhSelectionReducer } from './hocSinhSelectionReducer';
import { combineReducers } from 'redux';

export const hocSinhReducer = combineReducers({
    hocSinhSelection: hocSinhSelectionReducer,
    hocSinhHoTro: hocSinhHoTroReducer
})